const Pluralize = (str, count) => (count > 1 && str[str.length - 1] !== 's' ) ?`${str}s` : str

export default Pluralize;
